export default "__VITE_ASSET__BQOfsl1J__"